/**
 * Buy requests are read only by the AI engine (parse-buy-request, shared with Search).
 * There is deliberately no client-side pattern reader: a failed read is shown, never guessed.
 */
export const GRAMS_PER_LB = 453.592;
